import { CategoryItem } from "../../contracts/Shop";
import { ProductSlim } from "../../contracts/Product";
import { DataMapper } from "..";

export function fetchHierarchyToHierarchy(hierarchy: any): Array<CategoryItem> {
  const mapper = DataMapper();
  return (hierarchy.tree?.children || []).map((child: any) => {
    return {
      name: child.name,
      path: child.path,
      title: child.title?.content?.text,
      description: child.description?.content,
      thumbnail: child.thumbnail?.content?.firstImage,
      categories: child.children || [],
      topMenu: child.topMenu?.content?.value,
      subMenu: child.subMenu?.content?.value,
      products: (child?.children || []).map((product: any): ProductSlim => {
        return {
          id: product.id,
          name: product.name,
          path: product.path,
          sku: product.sku,
          variant: mapper.API.Object.APIProductVariantToProductVariant(
            product.defaultVariant,
          ),
          topics: [],
          brand: product.brand?.content?.text,
        };
      }),
    };
  });
}

